export default {
  getProjects: {
    server: '/projects',
    method: 'get',
  },
  getProject: {
    server: '/projects/{projectId}',
    method: 'get',
  },
  addProject: {
    server: '/projects',
    method: 'post',
  },
  putProject: {
    server: '/projects/{projectId}',
    method: 'put',
  },
  deleteProject: {
    server: '/projects/{projectId}',
    method: 'delete',
  },

  /**
   * @deprecated
   */
  getProjectDeviceTypes: {
    server: '/projects/{projectId}/device-types',
    method: 'get',
  },

  getProjectMeasurements: {
    server: '/projects/{projectId}/measurements',
    method: 'get',
  },
  getProjectCategories: {
    server: '/projects/{projectId}/categories',
    method: 'get',
  },
  getProjectMarkers: {
    server: '/projects/{projectId}/markers',
    method: 'get',
  },
  getProjectTopo: {
    server: '/projects/{projectId}/topo',
    method: 'get',
  },
  getTree: {
    server: '/projects/{projectId}/tree',
    method: 'get',
  },
  getMembers: {
    server: '/projects/{projectId}/members',
    method: 'get',
  },
  putMembers: {
    server: '/projects/{projectId}/members',
    method: 'put',
  },
  getThresholds: {
    server: '/projects/{projectId}/thresholds',
    method: 'get',
  },
};
